import { Component, Input } from '@angular/core';
import { BudgetActualModel, ProjectModel } from '../../../../../hub_schema/hubTypes';

@Component({
    selector: 'app-workday-financials-panel',
    templateUrl: './workday-financials-panel.component.html',
    styleUrl: './workday-financials-panel.component.scss',
    standalone: false
})
export class WorkdayFinancialsPanelComponent {
    @Input() public project: ProjectModel;

    public getSeriesWidth(ba: BudgetActualModel): number {
        const percentage = (ba.totalActualUsdAmount / ba.totalBudgetUsdAmount) * 100;

        if (percentage > 100) {
            return 100;
        }

        if (percentage < 0) {
            return 0;
        }

        return percentage;
    }

    public getTotalBudgetedExpenses(): number {
        return this.project.budgetsAndActuals!.reduce((total, ba) => {
            return total + ba.totalBudgetUsdAmount;
        }, 0);
    }

    public getTotalActualExpenses(): number {
        return this.project.budgetsAndActuals!.reduce((total, ba) => {
            return total + ba.totalActualUsdAmount;
        }, 0);
    }
}
